import React from 'react'

export const IntegrationsIcon = ({ isActive }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.9686V5C9 3.34314 10.3432 2 12 2C13.6568 2 15 3.34314 15 5V6.00285"
        stroke={isActive ? '#FFFFFF' : '#2D264B'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 12.002V19.0002C15 20.6571 13.6568 22.0002 12 22.0002C10.3432 22.0002 9 20.6571 9 19.0002V17.9852"
        stroke={isActive ? '#FFFFFF' : '#2D264B'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 15H4.99207C3.33959 15 2 13.6568 2 12C2 10.3432 3.33959 9 4.99207 9H5.9943"
        stroke={isActive ? '#FFFFFF' : '#2D264B'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 9H18.9944C20.6543 9 22 10.3432 22 12C22 13.6568 20.6543 15 18.9944 15H18.0331"
        stroke={isActive ? '#FFFFFF' : '#2D264B'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
